import React, { useRef } from 'react';
import { ActionMenu } from '../action-menu';
import { IconID } from '../icon';
import { Horizontal } from '../layout';
import { Popover } from '../popover';
import { Button } from './button';
import styles from './multi-select-button.module.scss';
export const MultiSelectButton = ({ actionsMenuConfig, isDropdownDisabled, primaryButton, className, }) => {
    const [isDropdownVisible, setDropdownVisible] = React.useState(false);
    const toggleDropDown = () => {
        setDropdownVisible((dropdownVisible) => !dropdownVisible);
    };
    const chevronRef = useRef(null);
    const wrapWithCloseDropdown = (onClick) => {
        return (event) => {
            setDropdownVisible(false);
            onClick(event);
        };
    };
    const getActionMenu = () => {
        const updatedActionMenuConfig = actionsMenuConfig.map((ele) => {
            return {
                ...ele,
                onClick: wrapWithCloseDropdown(ele.onClick),
            };
        });
        return (React.createElement(ActionMenu, { show: isDropdownVisible, menuItemGroups: [{ title: '', items: updatedActionMenuConfig }] }));
    };
    return (React.createElement(Horizontal, { className: className },
        React.createElement(Button, { type: primaryButton.type, icon: primaryButton.icon, text: primaryButton.text, isDisabled: primaryButton.isDisabled, tooltip: primaryButton.tooltip, className: styles.primaryButton, "data-testid": "multi-select-button-primary", onClick: wrapWithCloseDropdown(primaryButton.onClick), borderPlacement: "leftOnly" }),
        React.createElement("div", { ref: chevronRef },
            React.createElement(Button, { type: primaryButton.type, icon: IconID.CHEVRON_DOWN, isDisabled: isDropdownDisabled, className: styles.dropdownButton, onClick: toggleDropDown, borderPlacement: "rightOnly", "data-testid": "multi-select-button-dropdown" })),
        React.createElement(Popover, { targetRef: chevronRef, content: getActionMenu(), align: "bottom-end", isVisible: isDropdownVisible, "data-testid": "multi-select-button-action-menu", onClickOutside: () => setDropdownVisible(false) })));
};
//# sourceMappingURL=multi-select-button.js.map